import { render, staticRenderFns } from "./VagaProfile.vue?vue&type=template&id=c8f5dfa4&scoped=true"
import script from "./VagaProfile.vue?vue&type=script&lang=js"
export * from "./VagaProfile.vue?vue&type=script&lang=js"
import style0 from "./VagaProfile.vue?vue&type=style&index=0&id=c8f5dfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f5dfa4",
  null
  
)

export default component.exports